import { authedApiFetch } from 'utils/Api';

const salesforceTasksService = {
  getTasks: async (limit = 50) => {
    const response = await authedApiFetch({
      endpoint: '/salesforce_tasks',
      method: 'GET',
      params: { limit },
    });

    return response;
  }
};

export default salesforceTasksService;
